import { getLocale } from './browser';
import { t, translateText } from './index';

const labels: Record<string, string> = {
  ORG_OWNER: 'Owner',
  ORG_MANAGER: 'Manager',
  ORG_OFFICER: 'Officer',
  ORG_KYC_OFFICER: 'KYC Officer',
  ORG_KYB_OFFICER: 'KYB Officer',
  ORG_VIEWER: 'Viewer',
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low',
  UNASSESSED: 'Unassessed',
  PENDING: 'Pending',
  COMPLETED: 'Completed',
  PROCESSING: 'Processing',
  FAILED: 'Failed',
  DRAFT: 'Saved Draft',
  ACCEPTED: 'Client accepted',
  REJECTED: 'Client rejected',
};
export const enumLabel = (value: string) =>
  value === 'ORG_VIEWER' ? t('common.viewer') : translateText(labels[value] ?? value);
export const riskLabel = (value: string) => {
  if (value === 'UNASSESSED') {
    return t('reports.unassessed');
  }
  if (value === 'HIGH') {
    return t('ui.highRisk');
  }
  if (value === 'MEDIUM') {
    return t('ui.mediumRisk');
  }
  if (value === 'LOW') {
    return t('ui.lowRisk');
  }
  return t('reports.pending');
};

const statusLabels: Record<string, [string, string]> = {
  resolving_identity: ['Resolving identity', 'در حال تطبیق هویت'],
  following_up: ['Investigating open questions', 'در حال بررسی پرسش‌های باقی‌مانده'],
  screening: ['Running required checks', 'در حال انجام بررسی‌های ضروری'],
  assembling: ['Preparing report', 'در حال تهیه گزارش'],
  resolved: ['Required questions resolved', 'پرسش‌های ضروری پاسخ داده شدند'],
  no_new_leads: ['No useful new leads', 'سرنخ جدید مفیدی یافت نشد'],
  budget_exhausted: ['Research limit reached', 'محدودیت تحقیق پایان یافت'],
  CONFIRMED: ['Confirmed', 'تأییدشده'],
  DISMISSED: ['Dismissed', 'ردشده'],
  FINISHED: ['Finished', 'تکمیل‌شده'],
  PARTIAL: ['Partial', 'ناقص'],
  complete: ['Complete', 'کامل'],
  completed: ['Completed', 'تکمیل‌شده'],
  pending: ['Pending', 'در انتظار بررسی'],
  searching: ['Searching', 'در حال جست‌وجو'],
  reading: ['Reading', 'در حال خواندن منابع'],
  analyzing: ['Analyzing', 'در حال تحلیل'],
  no_results: ['No results', 'بدون نتیجه'],
  not_retrieved: ['Found, not retrieved', 'یافت‌شده، دریافت‌نشده'],
  limited: ['Limited evidence coverage', 'پوشش محدود شواهد'],
  no_relevant_evidence: ['No relevant evidence', 'شواهد مرتبطی پیدا نشد'],
  inaccessible: ['Inaccessible', 'دسترسی ممکن نیست'],
  provider_failure: ['Provider failure', 'خطای سرویس'],
  researched: ['Researched', 'بررسی‌شده'],
  no_findings: ['No findings', 'بدون یافته'],
  not_screened: ['Not screened by policy', 'طبق سیاست بررسی نشده'],
  insufficient_evidence: ['Insufficient evidence', 'شواهد ناکافی'],
  failed: ['Failed', 'ناموفق'],
  matching: ['Matching', 'مطابقت دارد'],
  uncertain: ['Uncertain', 'نامشخص'],
  unrelated: ['Unrelated', 'نامرتبط'],
  PASSPORT: ['Passport', 'گذرنامه'],
  NATIONAL_ID: ['National ID', 'کارت ملی'],
  RESIDENCY_PERMIT: ['Residency permit', 'کارت اقامت'],
  VOTER_ID: ['Voter ID', 'کارت رأی‌دهنده'],
  CERTIFICATE_OF_INCORPORATION: ['Certificate of incorporation', 'گواهی ثبت شرکت'],
  TRADE_LICENSE: ['Trade license', 'مجوز فعالیت'],
  COMMERCIAL_REGISTRY_EXTRACT: ['Commercial registry extract', 'استعلام ثبت تجاری'],
  MERGER_ACQUISITION_DOCUMENT: ['Merger and acquisition document', 'سند ادغام یا تملک'],
};
export const statusLabel = (value: string) =>
  statusLabels[value]?.[getLocale() === 'fa' ? 1 : 0] ?? enumLabel(value);
export const notificationLabel = ({ title, eventKey }: { title: string; eventKey?: string }) => {
  const [kind, , status] = (eventKey ?? '').split(':');
  if ((kind !== 'generation' && kind !== 'decision') || !status) {
    return title;
  }
  const separator = title.lastIndexOf(': ');
  if (separator < 0) {
    return title;
  }
  return `${title.slice(0, separator)}: ${statusLabel(status)}`;
};
